<template>
  <div class="resultsV2-bottom-block">
    <img class="resultsV2-bottom-skill-logo" alt="" :src="getLogo()" />
    <span class="resultsV2-bottom-skill-title">Vous avez une marge de progression possible en  {{getSkill()}} </span>
    <span class="resultsV2-bottom-skill-text">{{getText()}}</span>
    <span class="resultsV2-bottom-skill-improve">Comment améliorer votre {{getSkillName()}} :</span>
    <div class="icon-container or-gradient"><i class="yuzu-icon microscope_icon_V2"></i></div>
      <div class="resultsV2-bottom-skill-improve-list ">
        <div class="resultsV2-bottom-skill-improve-element">
          <div class="resultsV2-bottom-skill-improve-icon" :class="'icon-container or-gradient'"><i class="yuzu-icon" :class="getIcon1()"></i></div>
          <span class="resultsV2-bottom-skill-improve-text">{{getText1()}} </span>
        </div>
        <div class="resultsV2-bottom-skill-improve-element">
          <div class="resultsV2-bottom-skill-improve-icon" :class="'icon-container or-gradient'"><i class="yuzu-icon" :class="getIcon2()"></i></div>
          
          <span class="resultsV2-bottom-skill-improve-text">{{getText2()}}</span>
        </div>
        <div class="resultsV2-bottom-skill-improve-element">
          <div class="resultsV2-bottom-skill-improve-icon" :class="'icon-container or-gradient'"><i class="yuzu-icon" :class="getIcon3()"></i></div>
          <span class="resultsV2-bottom-skill-improve-text">{{getText3()}}</span>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  props: ['skill'],
  methods: {
    getLogo() {
      var text = "/images/resultsV2/";
      switch (this.skill) {
        case 'stress_manage':
          text += "Gestion-stress_icon_V2.svg";
          break;
        case 'adaptability':
          text += "Adaptabilité_icon_V2.svg";
          break;
        case 'pb_solving':
          text += "Resolution-probleme_icon_V2.svg";
          break;
        case 'auto_efficient':
          text += "Confiance-compétence_icon_V2.svg";
          break;
        case 'active_listen':
          text += "Ecoute-active_icon_V2.svg";
          break;
        case 'empathy':
          text += "Empathie_icon_V2.svg";
          break;
        case 'time_manage':
          text += "Gestion-temps_icon_V2.svg";
          break;
        case 'planning':
          text += "Planification_icon_V2.svg";
          break;
        case 'decisions':
          text += "Prise-décision_icon_V2.svg";
          break;
        default:
          break;
      }
      return text;
    },
    getSkill() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Gestion du stress";
          break;
        case 'adaptability':
          text = "Adaptabilité";
          break;
        case 'pb_solving':
          text = "Résolution de problèmes";
          break;
        case 'auto_efficient':
          text = "prenant confiance en vos capacités";
          break;
        case 'active_listen':
          text = "Ecoute active";
          break;
        case 'empathy':
          text = "Empathie";
          break;
        case 'time_manage':
          text = "Gestion du temps";
          break;
        case 'planning':
          text = "Planification";
          break;
        case 'decisions':
          text = "Prise de décision";
          break;
        default:
          break;
      }
      return text;
    },
    getSkillName() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "gestion du stress";
          break;
        case 'adaptability':
          text = "adaptabilité";
          break;
        case 'pb_solving':
          text = "Résolution de problèmes";
          break;
        case 'auto_efficient':
          text = "confiance en vos capacités";
          break;
        case 'active_listen':
          text = "écoute active";
          break;
        case 'empathy':
          text = "empathie";
          break;
        case 'time_manage':
          text = "gestion du temps";
          break;
        case 'planning':
          text = "planification";
          break;
        case 'decisions':
          text = "prise de décision";
          break;
        default:
          break;
      }
      return text;
    },
    getText() {
      var text = "";
      switch (this.skill) {
        case 'adaptability':
          text = "Etre adaptable, c’est reconnaître et accepter le changement et revoir ses méthodes de travail si celles-ci ne collent plus au contexte. Dans un monde en mouvement constant, c’est une compétence clé pour évoluer de façon sereine dans un cadre professionnel.";
          break;
        case 'auto_efficient':
          text = "Avoir confiance en ses compétences, c'est reconnaître sa valeur et oser mettre en avant ses talents. C'est essentiel pour progresser et saisir les opportunités professionnelles.";
          break;
        case 'active_listen':
          text = "Pratiquer l'écoute active, c'est être pleinement présent et attentif aux messages verbaux et non-verbaux de ses interlocuteurs. C'est fondamental pour construire des relations professionnelles de qualité.";
          break;
        case 'empathy':
          text = "Être empathique, c'est comprendre et prendre en compte les émotions et le point de vue des autres. C'est une compétence clé pour le travail en équipe et le leadership.";
          break;
        case 'time_manage':
          text = "Gérer son temps efficacement, c'est savoir prioriser ses tâches et organiser son travail de manière optimale. C'est essentiel pour atteindre ses objectifs tout en maintenant un équilibre.";
          break;
        case 'stress_manage':
          text = "Savoir gérer son stress, c'est garder le contrôle de soi pour agir efficacement face à des situations de tension. C’est une compétence clé pour la plupart des postes où il faut savoir garder une approche rationnelle malgré un environnement qui peut être stressant.";
          break;
        case 'planning':
          text = "Planifier efficacement, c'est savoir organiser et séquencer les actions nécessaires pour atteindre un objectif. C'est fondamental pour la gestion de projet et l'atteinte des résultats.";
          break;
        case 'decisions':
          text = "Prendre des décisions, c'est savoir analyser une situation et choisir la meilleure option possible en tenant compte des contraintes. C'est une compétence clé pour tout poste à responsabilité.";
          break;
        case 'pb_solving':
          text = "Résoudre des problèmes, c’est la capacité à identifier et à traiter efficacement les problèmes ou les défis auxquels on est confronté. C'est une compétence essentielle pour comprendre les enjeux d’une situation et prendre des décisions rationnelles.";
          break;
        default:
          break;
      }
      return text;
    },
    getText1() {
      var text = "";
      switch (this.skill) {
        case 'adaptability':
          text = "Prendre du recul sur vos méthodes de travail et apprendre à apprécier le changement";
          break;
        case 'auto_efficient':
          text = "Identifier et valoriser ses réussites";
          break;
        case 'active_listen':
          text = "Pratiquer la reformulation";
          break;
        case 'empathy':
          text = "S'exercer à reconnaître les émotions";
          break;
        case 'time_manage':
          text = "Utiliser des outils de planification";
          break;
        case 'stress_manage':
          text = "Partager sa situation avec ses collaborateurs et sa hiérarchie";
          break;
        case 'planning':
          text = "Utiliser des outils de gestion de projet";
          break;
        case 'decisions':
          text = "S'entraîner à l'analyse de risques";
          break;
        case 'pb_solving':
          text = "S’exercer à travers des jeux (jeux de société, jeu de logique et de réflexion, jeux vidéos, …)";
          break;
        default:
          break;
      }
      return text;
    },
    getText2() {
      var text = "";
      switch (this.skill) {
        case 'adaptability':
          text = "Essayer d’aborder les problèmes sous d’autres angles";
          break;
        case 'auto_efficient':
          text = "Se fixer des objectifs atteignables";
          break;
        case 'active_listen':
          text = "Poser des questions pertinentes";
          break;
        case 'empathy':
          text = "Pratiquer l'écoute bienveillante";
          break;
        case 'time_manage':
          text = "Définir des priorités claires";
          break;
        case 'stress_manage':
          text = "Repousser sa zone de confort afin de s’acclimater aux situations de tension";
          break;
        case 'planning':
          text = "Apprendre à décomposer les objectifs";
          break;
        case 'decisions':
          text = "Développer son esprit critique";
          break;
        case 'pb_solving':
          text = "Essayer d’aborder les problèmes sous différentes perspectives";
          break;
        default:
          break;
      }
      return text;
    },
    getText3() {
      var text = "";
      switch (this.skill) {
        case 'adaptability':
          text = "S’éloigner de ses routines et de ses habitudes";
          break;
        case 'auto_efficient':
          text = "Solliciter des feedbacks";
          break;
        case 'active_listen':
          text = "Éliminer les distractions pendant les échanges";
          break;
        case 'empathy':
          text = "Développer sa curiosité pour les autres";
          break;
        case 'time_manage':
          text = "Apprendre à dire non";
          break;
        case 'stress_manage':
          text = "Apprendre le “lâcher prise”";
          break;
        case 'planning':
          text = "Développer sa vision moyen/long terme";
          break;
        case 'decisions':
          text = "Apprendre des décisions passées";
          break;
        case 'pb_solving':
          text = "Pratiquer le brainstorming régulièrement, seul ou en groupe, pour développer sa créativité face aux défis";
          break;
        default:
          break;
      }
      return text;
    },
    getIcon1() {
      var text = "";
      switch (this.skill) {
        case 'adaptability':
        text = "improve_icon_V2";
          break;
        case 'auto_efficient':
        text = "microscope_icon_V2";
          break;
        case 'active_listen':
        text = "improve_icon_V2";
          break;
        case 'empathy':
        text = "improve_icon_V2";
          break;
        case 'time_manage':
        text = "improve_icon_V2";
          break;
        case 'stress_manage':
        text = "improve_icon_V2";
          break;
        case 'planning':
        text = "improve_icon_V2";
          break;
        case 'decisions':
        text = "improve_icon_V2";
          break;
        case 'pb_solving':
        text = "improve_icon_V2";
          break;
        default:
          break;
      }
      return text;
    },
    getIcon2() {
      var text = "";
      switch (this.skill) {
        case 'adaptability':
        text = "improve_icon_V2";
          break;
        case 'auto_efficient':
        text = "improve_icon_V2";
          break;
        case 'active_listen':
        text = "improve_icon_V2";
          break;
        case 'empathy':
        text = "improve_icon_V2";
          break;
        case 'time_manage':
        text = "improve_icon_V2";
          break;
        case 'stress_manage':
        text = "improve_icon_V2";
          break;
        case 'planning':
        text = "improve_icon_V2";
          break;
        case 'decisions':
        text = "improve_icon_V2";
          break;
        case 'pb_solving':
        text = "improve_icon_V2";
          break;
        default:
          break;
      }
      return text;
    },
    getIcon3() {
      var text = "";
      switch (this.skill) {
        case 'adaptability':
        text = "improve_icon_V2";
          break;
        case 'auto_efficient':
        text = "improve_icon_V2";
          break;
        case 'active_listen':
        text = "improve_icon_V2";
          break;
        case 'empathy':
        text = "improve_icon_V2";
          break;
        case 'time_manage':
        text = "improve_icon_V2";
          break;
        case 'stress_manage':
        text = "improve_icon_V2";
          break;
        case 'planning':
        text = "improve_icon_V2";
          break;
        case 'decisions':
        text = "improve_icon_V2";
          break;
        case 'pb_solving':
          text = "improve_icon_V2";
          break;
        default:
          break;
      }
      return text;
    },
  }
};
</script>

<style>
.resultsV2-bottom-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    position: relative;
    padding: 32px 32px 32px 32px;
    background: #0f0e0e;
    border: 2px solid #464646;
    border-radius: 4px;
}

.resultsV2-bottom-skill-logo {
    flex-shrink: 0;
    position: relative;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
}

.resultsV2-bottom-skill-title {
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    color: #ffffff;
    font-family: "Bio Sans-Regular", Helvetica;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 8px;
}
.resultsV2-bottom-skill-text {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
    color: rgba(255, 255, 255, 0.75);
    font-family: "Bio Sans-Regular", Helvetica;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 24px;
}

.resultsV2-bottom-skill-improve {
    align-self: stretch;
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    color: #ffffff;
    font-family: "Bio Sans-Regular", Helvetica;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 16px;
}

.resultsV2-bottom-skill-improve-list {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: 24px;
    position: relative;
}

.resultsV2-bottom-skill-improve-element {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    gap: 12px;
    position: relative;
}
.resultsV2-bottom-skill-improve-icon {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
}
.resultsV2-bottom-skill-improve-text {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    position: relative;
    color: rgba(255, 255, 255, 0.75);
    font-family: "Bio Sans-Regular", Helvetica;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
}

.resultsV2-communication-colour {
  color:  #b09fff;
}

.resultsV2-communication-bg-colour {
  background: linear-gradient(180deg, #b09fff, #8d79f6)!important;
}
</style>